import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IPreviewRow } from '@feathr/blackbox';
import { Alert, AvatarV2 as Avatar, Card, Spinner } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import PersonPreview from '../../DataPage/PersonPage/PersonPreview';

import * as styles from './PreviewCard.css';

interface IProps {
  row: IPreviewRow;
  tagIds: string[];
}

function PreviewCard({ row, tagIds }: IProps): JSX.Element {
  const { result, error } = row;
  const { Persons } = useStore();
  const person = result ? Persons.create(result) : null;
  const { t } = useTranslation();

  if (person?.isPending) {
    return <Spinner />;
  }

  return (
    <Card
      className={styles.root}
      title={
        person ? (
          <>
            <Avatar name={person.get('name')} placeholder={person.get('placeholder')} />
            <div>{person.get('name')}</div>
          </>
        ) : (
          t('This person cannot be imported.')
        )
      }
    >
      {person && <PersonPreview person={person} tagIds={tagIds} />}
      {error && <Alert title={error} type={'danger'} />}
    </Card>
  );
}

export default observer(PreviewCard);
